var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "functionForm",
              attrs: {
                model: _vm.functionForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.slider") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.changeFunctionCfg },
                      model: {
                        value: _vm.functionForm.sliderShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.functionForm, "sliderShow", $$v)
                        },
                        expression: "functionForm.sliderShow",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.functionForm.sliderShow,
                      expression: "functionForm.sliderShow",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.slider_range") + "(%)" },
                },
                [
                  _c("el-slider", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      min: 0,
                      max: 100,
                      "input-size": "mini",
                      range: "",
                    },
                    on: { change: _vm.changeFunctionCfg },
                    model: {
                      value: _vm.functionForm.sliderRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.functionForm, "sliderRange", $$v)
                      },
                      expression: "functionForm.sliderRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.functionForm.sliderShow,
                      expression: "functionForm.sliderShow",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.slider_bg") },
                },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: { predefine: _vm.predefineColors },
                    on: { change: _vm.changeFunctionCfg },
                    model: {
                      value: _vm.functionForm.sliderBg,
                      callback: function ($$v) {
                        _vm.$set(_vm.functionForm, "sliderBg", $$v)
                      },
                      expression: "functionForm.sliderBg",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.functionForm.sliderShow,
                      expression: "functionForm.sliderShow",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.slider_fill_bg") },
                },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: { predefine: _vm.predefineColors },
                    on: { change: _vm.changeFunctionCfg },
                    model: {
                      value: _vm.functionForm.sliderFillBg,
                      callback: function ($$v) {
                        _vm.$set(_vm.functionForm, "sliderFillBg", $$v)
                      },
                      expression: "functionForm.sliderFillBg",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.functionForm.sliderShow,
                      expression: "functionForm.sliderShow",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.slider_text_color") },
                },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: { predefine: _vm.predefineColors },
                    on: { change: _vm.changeFunctionCfg },
                    model: {
                      value: _vm.functionForm.sliderTextClolor,
                      callback: function ($$v) {
                        _vm.$set(_vm.functionForm, "sliderTextClolor", $$v)
                      },
                      expression: "functionForm.sliderTextClolor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.chart.render === "antv" &&
                        (_vm.chart.type.includes("line") ||
                          _vm.chart.type.includes("bar") ||
                          _vm.chart.type.includes("area")),
                      expression:
                        "chart.render === 'antv' && (chart.type.includes('line') || chart.type.includes('bar') || chart.type.includes('area'))",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.empty_data_strategy") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeFunctionCfg },
                      model: {
                        value: _vm.functionForm.emptyDataStrategy,
                        callback: function ($$v) {
                          _vm.$set(_vm.functionForm, "emptyDataStrategy", $$v)
                        },
                        expression: "functionForm.emptyDataStrategy",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "breakLine" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.break_line"))),
                      ]),
                      _c("el-radio", { attrs: { label: "setZero" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.set_zero"))),
                      ]),
                      _c("el-radio", { attrs: { label: "ignoreData" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.ignore_data"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }